import React from "react";
import { ChangeEvent } from "react";

interface IManualSelectProps {
    value?: string | number | string[];
    name?: string;

    className?: string;
    innerClassName?: string;

    disabled?: boolean;

    onChange?: (e: ChangeEvent<HTMLSelectElement> | ChangeEvent<HTMLInputElement>) => void;

    onBlur?: (e: React.FocusEvent<HTMLSelectElement> | React.FocusEvent<HTMLInputElement>) => void;
    onFocus?: (e: React.FocusEvent<HTMLSelectElement> | React.FocusEvent<HTMLInputElement>) => void;
}

interface IManualSelectState {
    value: string;
    showInput: boolean;

    inputAutoFocus: boolean;
}

const OTHER = "__internal_other";

class ManualSelect extends React.Component<IManualSelectProps, IManualSelectState> {
    constructor(props: Readonly<IManualSelectProps>) {
        super(props);

        this.state = {
            inputAutoFocus: true,
            showInput: false,
            value: ""
        };

        this.handleSelectChanged = this.handleSelectChanged.bind(this);
        this.handleInputChanged = this.handleInputChanged.bind(this);
        this.onBlurHook = this.onBlurHook.bind(this);
    }

    public componentDidMount() {
        this.applyValue();
    }

    public componentDidUpdate(prevProps: Readonly<IManualSelectProps>) {
        if (prevProps.value !== this.props.value && this.props.value !== this.state.value) {
            // We're being provided a new value
            this.applyValue();
        }
    }

    public render() {
        return (
            <span className={"manual-select-root" + (this.state.showInput ? " manual-input" : "") + (" " + this.props.className)}>
                <select className={this.props.innerClassName} onChange={this.handleSelectChanged} name={!this.state.showInput ? this.props.name : ""} value={this.state.showInput ? OTHER : this.state.value} onBlur={this.onBlurHook} onFocus={this.props.onFocus} disabled={this.props.disabled}>
                    {this.props.children}
                    <option value={OTHER}>Other</option>
                </select>
                {
                    this.state.showInput
                        ? <input type="text" className={this.props.innerClassName} name={this.props.name} value={this.state.value} onChange={this.handleInputChanged} autoFocus={this.state.inputAutoFocus} onBlur={this.props.onBlur} onFocus={this.props.onFocus} disabled={this.props.disabled} />
                        : ""
                }
            </span>
        );
    }

    private handleSelectChanged(e: ChangeEvent<HTMLSelectElement>) {
        const value = e.currentTarget.value;

        this.setState({
            inputAutoFocus: true,
            showInput: value === OTHER,
            value: value === OTHER ? "" : value
        });

        if (this.props.onChange) {
            if (value === OTHER) {
                e.currentTarget.value = "";
            }

            if (this.props.name) {
                e.currentTarget.name = this.props.name;
            }

            this.props.onChange(e);
        }
    }

    private handleInputChanged(e: ChangeEvent<HTMLInputElement>) {
        const value = e.currentTarget.value;

        this.setState({
            value
        });

        if (this.props.onChange) {
            this.props.onChange(e);
        }
    }

    private onBlurHook(e: React.FocusEvent<HTMLSelectElement>) {
        if (!this.state.showInput && this.props.onBlur) {
            this.props.onBlur(e);
        }
    }


    private applyValue() {
        const value = this.props.value;
        let foundValue = false;
        React.Children.forEach(this.props.children, c => {
            if (!React.isValidElement<HTMLOptionElement>(c)) {
                return;
            }

            if (c.type === "option" && c.props.value === value) {
                // Found option to select
                foundValue = true;
            }
        });

        this.setState({
            inputAutoFocus: false,
            showInput: !foundValue,
            value: (value || "").toString(),
        })
    }
}

export default ManualSelect;
